// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const RgaSearchResults = t.struct({
    analysisResult: t.maybe(t.String),
    analysisStatus: t.String,
    analystId: t.String,
    componentSerialNumber: t.String,
    dtacCaseNumber: t.String,
    engineSerialNumber: t.String,
    factoryCode: t.String,
    failureDescription: t.maybe(t.String),
    findings: t.maybe(t.String),
    logNumbers: t.String,
    machineSerialNumber: t.String,
    nccaCarNumber: t.String,
    partDescription: t.String,
    partNumber: t.String,
    requestDate: t.Number,
    requesterType: t.String,
    rgaDealer: t.String,
    rgaNotes: t.maybe(t.String),
    rgaNumber: t.String,
    rgaStatus: t.String,
    rgaSubType: t.String,
    shipToLocationCode: t.String,
    shippedToLocation: t.String,
    subSystem: t.maybe(t.String),
    supplierAnalysis: t.maybe(t.String),
    warrantyClaimNumber: t.String
}, {
    name: 'RgaSearchResults',
    strict: true
});

export const getDefaultState = () => new RgaSearchResults({
    analysisResult: '',
    analysisStatus: '',
    analystId: '',
    componentSerialNumber: '',
    dtacCaseNumber: '',
    engineSerialNumber: '',
    factoryCode: '',
    failureDescription: '',
    findings: '',
    logNumbers: '',
    machineSerialNumber: '',
    nccaCarNumber: '',
    partDescription: '',
    partNumber: '',
    requestDate: 0,
    requesterType: '',
    rgaDealer: '',
    rgaNotes: '',
    rgaNumber: '',
    rgaStatus: '',
    rgaSubType: '',
    shipToLocationCode: '',
    shippedToLocation: '',
    subSystem: '',
    supplierAnalysis: '',
    warrantyClaimNumber: ''
});

RgaSearchResults.prototype.stripLeadingZerosForRgaNumber = function stripLeadingZerosForRgaNumber() {

    const strippedRgaNumber = this.rgaNumber.replace(/^0+/, '');

    return strippedRgaNumber;

};

export default RgaSearchResults;



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/state/rga-search-result.js